import React from 'react';
import { Button, Dropdown, Icon, Text, theme } from 'components';
import errorReporter from '@app/errorReporter';
import { Menu, message } from 'antd';
import styled from 'styled-components';
import axios from 'axios';

import {
  PickerOptions,
  PickerResponse,
} from 'filestack-js/build/main/lib/picker';
import Swal from 'sweetalert2';
import fileStackClient from '@app/filestack';

const CovidSectionLA = ({
  appointment,
  setValidatedAck,
  validatedAck,
  setLACovidOverridden,
  sendReminder,
  covid19ReminderSent,
  sendingReminder,
}: any) => {
  const openFilePicker = async () => {
    const processResults = async (results: PickerResponse) => {
      const PDF = results.filesUploaded[0].url;
      await axios.post('/covid19/appointment/updateAction', {
        appointmentId: appointment.id,
        note: 'PDF ADDED',
        type: 'PDF',
        PDF,
      });
      setValidatedAck(true);
    };

    const opts: PickerOptions = {
      accept: 'application/pdf',
      maxFiles: 1,
      onUploadDone: results => processResults(results),
    };

    const picker = fileStackClient.picker(opts);
    picker.open();
  };

  const override = async () => {
    const { value } = await Swal.fire({
      title: 'Override and allow showing',
      text: 'Are you sure you want to allow this showing to proceed without an acknowledgment from the showing agent?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#62cb31',
      confirmButtonText: 'Confirm',
      reverseButtons: true,
    });
    if (value) {
      try {
        await axios.post('/covid19/appointment/updateAction', {
          appointmentId: appointment.id,
          note: 'COVID-19 FORM OVERRIDDEN',
          type: 'override',
        });
        setValidatedAck(true);
        setLACovidOverridden(true);
      } catch (err) {
        errorReporter.error(err);
      }
    }
  };

  const renderMenu = () => (
      <Menu>
        <Menu.Item
          key="send-covid-reminder"
          data-cy="send-covid-reminder"
          onClick={() => {
            sendReminder();
            message.success('COVID-19 reminder sent');
          }}
          disabled={covid19ReminderSent || sendingReminder}
        >
          {covid19ReminderSent ? 'COVID-19 reminder sent' : 'Send Reminder'}
        </Menu.Item>
        <Menu.Item
          key="add-covid-pdf"
          data-cy="add-covid-pdf"
          onClick={openFilePicker}
        >
          Add PDF
        </Menu.Item>
        <Menu.Item
          key="override-covid-pdf"
          data-cy="override-covid-pdf"
          onClick={override}
        >
          Override
        </Menu.Item>
      </Menu>
    );

  return (
    <StyledContainer>
      {!validatedAck && (
        <Dropdown dropdownRender={renderMenu} trigger={['click']}>
          <StyledDropDownButton type="link">
            Manage
            <StyledIcon type="antdDownOutlined" width={14} color={'blue6'} />
          </StyledDropDownButton>
        </Dropdown>
      )}
    </StyledContainer>
  );
};

export default CovidSectionLA;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledIcon = styled(Icon)`
  margin-left: 5px;
`;

const StyledDropDownButton = styled(Button)`
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  color: ${theme.blue6};
  text-decoration: underline;
`;
